export default {
  data() {
    return {
      formData: this.getDefaultFormData(),
      loading: false,
      isSubmitting: false,
    };
  },
  methods: {
    getDefaultFormData() {
      return {
        code: '',
        name: '',
        phone: '',
        address: '',
        active: true,
        notes: '',
      };
    },

    resetForm() {
      this.formData = this.getDefaultFormData();
      this.clearAllErrors && this.clearAllErrors();
    },

    setFormData(data) {
      this.formData = {
        ...this.getDefaultFormData(),
        ...data,
      };
    },

    startLoading() {
      this.loading = true;
    },

    stopLoading() {
      this.loading = false;
    },

    startSubmitting() {
      this.isSubmitting = true;
    },

    stopSubmitting() {
      this.isSubmitting = false;
    },
  },
};
